'use client';
import React from 'react';
import DashboardLayout from '@/components/DashboardLayout';
import AdminKanban from '@/app/admin-dashboard/components/AdminKanban';

export default function AdminJobsPage() {
  return (
    <DashboardLayout role="admin">
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-extrabold text-foreground">Job Board</h1>
          <p className="text-sm text-muted-foreground mt-0.5">Manage and track all cleaning jobs</p>
        </div>
        <AdminKanban />
      </div>
    </DashboardLayout>
  );
}
